import { render, staticRenderFns } from "./BuyPerson.vue?vue&type=template&id=4aa6012c&scoped=true&"
import script from "./BuyPerson.vue?vue&type=script&lang=js&"
export * from "./BuyPerson.vue?vue&type=script&lang=js&"
import style0 from "./BuyPerson.vue?vue&type=style&index=0&id=4aa6012c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa6012c",
  null
  
)

export default component.exports